import React, { Component } from 'react';

import { Button, CardActions, List, ListItem } from 'react-md';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import RegistrationCard from '../../RegistrationCard';

class MinorList extends Component {
  constructor(props) {
    super(props);

    this.handleDeleteMinor = this.handleDeleteMinor.bind(this);
  }

  handleDeleteMinor(index) {
    const { currentRegistration, onSubmit } = this.props;

    let updateMinors = cloneDeep(currentRegistration.minors);
    pullAt(updateMinors, [index]);

    const minorList = {
      minors: updateMinors,
    };

    minorList.nextStep = (minorList.length > 0) ? 'minors/list' : 'minors';
    onSubmit(minorList);
  }

  render() {
    const { currentRegistration, onSubmit } = this.props;
    const minors = currentRegistration.minors ? currentRegistration.minors : [];
    return (
        <RegistrationCard title="Minors" subtitle="You can add up to (3) minors on a registration.">
          {/* smaller width so delete button closes to text */}
          <List>
            {minors.map((minor, index) => (
              <ListItem
                key={index}
                primaryText={`${minor.firstName} ${minor.lastName}`}
                onClick={() => onSubmit({ nextStep: `minors/${index}/contact-info` })}
              >
                {/*
                  as react-md's ListItem or ListItemControl only allow one action,
                  and we need two actions here:
                  - Click to go to item detail
                  - Click to delete
                */}
                {/* eslint-disable jsx-a11y/no-static-element-interactions */}
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {/* eslint-enable jsx-a11y/no-static-element-interactions */}
                  <Button
                    id="deleteMinor"
                    name="deleteMinor"
                    icon
                    primary
                    onClick={() => this.handleDeleteMinor(index)}
                  >close</Button>
                </div>
              </ListItem>
            ))}
          </List>
          <CardActions>
            {minors.length < 3 &&
              <Button
                raised
                label="Add Another Minor"
                secondary
                className="md-cell--left"
                onClick={() =>
                  onSubmit({ nextStep: `minors/${minors.length}/contact-info` })}
              />}
            <Button
              raised
              label="Save & Continue"
              primary
              className="md-cell--right"
              onClick={() => onSubmit({ nextStep: 'range-rules' })}
            />
          </CardActions>
        </RegistrationCard>
    )
  }
}

MinorList.propTypes = {};
MinorList.defaultProps = {};

export default MinorList;



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorList/MinorList.jsx